// Query keys for bundle (listing-variant) endpoints. Kept separate from
// `stockKeys`/`ratioKeys` in query-keys.ts to avoid namespace collision.
// The underlying API is still `/v1/listings*`; only the FE concept is "bundle".
export const bundleKeys = {
  all: ["listings"] as const,
  lists: ["listings", "list"] as const,
  list: (offset: number, limit: number, search?: string) =>
    ["listings", "list", { offset, limit, search }] as const,
  detail: (code: string) => ["listings", "detail", code] as const,
};
